import React, { Component } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import FilesUploadComponent from './component/file-upload-component.js';
import { usePromiseTracker } from "react-promise-tracker";
import Loader from 'react-loader-spinner';
import Tabs from './component/Tabs.js';
import unipi from "./component/cropped-navbar-header-1.png";
import method from "./component/Εικόνα1.png"


class App extends Component {

  render() {
    const LoadingIndicator = props => {
      const { promiseInProgress } = usePromiseTracker();
      return (promiseInProgress&&<div
        style={{ width: "80%",height: "80%"}}>
        <Loader type="ThreeDots" color="Blue" secondaryColor="Grey" height="100" width="100" /> </div>)}
    return (
      <div className="App">
        <img id='banner' src={unipi} alt='unipi'/>
        <Tabs>
        <div label="Main Application">
          <LoadingIndicator/>
          <FilesUploadComponent/>
        </div>
        <div label="Information">
          Follow -up dermoscopy images suffer from different type of variations main-ly generated due to
            the lack of standardized image capturing procedures and the evolution of morphological characteristics
            depending on the illness pro-gress. To avoid erroneous assessments concerning skin cancer, there is an
            immense need for an automated image registration tool to tackle with these variations. The objective of
            this work is to present an end-to-end automated tool for the successful registration of follow-up
            images leading to objective quantitative evaluation between two consecutive samples. The method is
            based on an alternative of Scale Invariant Feature Trasform, namely RootSIFT and the improved version
            Random Consensus algorithm. While hair in dermoscopy images can be a confusing factor to the computation
            of the transformation matrix, we add a hair removal procedure by clustering the detected features.
            This add-on significantly improves the performance of the proposed methodology. Initial results
            show that the proposed methodology can be efficiently utilized as a standalone application for
            manual evaluation of skin cancer pathogenies or integrated in the workflow of an automated classification technique.
            <h2>Basic Methodology</h2>
            <img src={method} />
        </div>
      </Tabs>
      </div>
    );
  }
}

export default App;
